import { createQueryParams } from '@/utils/query-params';
import { api } from './index';

const BASE_PATH = '/api/internal/tax_party';

// What the tax authority holds for a representative's tax id: what a document
// would print. The id never travels: the server reads it from a representative
// of a patient the user can see.
export interface TaxParty {
  taxId: string;
  name: string | null;
  registered: boolean;
  activities: Array<{ code: string; description: string }>;
  addresses: Array<{ address: string; locality: string; city: string }>;
}

export const taxPartiesApi = {
  // The lookup goes through the account routed for the document kind when given.
  show(representativeId: number, documentKind?: string): Promise<TaxParty> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?${createQueryParams({ representativeId, documentKind })}`,
    }).then(response => response.data.taxParty);
  },
};
